import React, { useState } from 'react'
import colors from '../utils/colors'
import PropTypes from 'prop-types'
import { CopyToClipboard } from 'react-copy-to-clipboard';

const ShareButtons = ({text, url}) => {
  let copiedTimeout = null
  const [copied, setCopied] = useState(false)
  const facebookShare = (e) => {
    e.preventDefault()
    // Can't share on local development
    const shareUrl = `https://www.facebook.com/dialog/share?app_id=1107984962866450&display=popup&href=${url}`
    window.open(shareUrl, '', 'width=617, height=547')
  }

  const twitterShare = (e) => {
    e.preventDefault()
    const shareUrl = `https://twitter.com/intent/tweet?text=${text}&url=${url}`
    window.open(shareUrl, '', 'width=619, height=406')
  }

  const linkedinShare = (e) => {
    e.preventDefault()
    const shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${text}`
    window.open(shareUrl, '', 'width=619, height=406')
  }

  const onCopy = () => {
    clearTimeout(copiedTimeout)
    setCopied(true)

    // Hide after 2 seconds
    copiedTimeout = setTimeout(() => {
      setCopied(false)
    }, 1000)
  }

  return (
    <div className="flex items-center justify-center lg:justify-start -mx-2">
      <div className="px-2 relative" style={{ width: '97px' }}>
        <CopyToClipboard text={url} onCopy={onCopy}>
          <div
            type="button"
            className="rounded border text-primary text-xs text-center px-2 py-1 cursor-pointer w-full"
            style={{borderColor: colors.primary}}
          >
            { copied ? 'Copied!' : 'Copy Link' }
          </div>
        </CopyToClipboard>
      </div>
      <div className="w-auto lg:w-1/3 px-2">
        <div className="flex items-center">
          <button onClick={facebookShare} type="button" className="cursor-pointer appearance-none">
            <img className="mr-2" src="/images/logos/khub_facebook-logo.svg" alt="facebook"/>
          </button>
          <button onClick={twitterShare} type="button" className="cursor-pointer appearance-none">
            <img className="mr-2" src="/images/logos/khub_twitter.svg" alt="twitter"/>
          </button>
          <button onClick={linkedinShare} type="button" className="cursor-pointer appearance-none">
            <img className="cursor-pointer" src="/images/logos/khub_linkedin.svg" alt="linkedin"/>
          </button>
        </div>
      </div>
    </div>
  )
}

ShareButtons.propTypes = {
  text: PropTypes.string,
  url: PropTypes.string
}

ShareButtons.defaultProps = {
  text: '',
  url: window.location.href,
}

export { ShareButtons }
